export default __webpack_public_path__ + "b21c04107b44604cf21f3c2c2a3dfe8d.svg";